import React from "react";
import "./Privacy_policy.css";

function PrivacyPolicy() {
  return (
    <div>
      <h1>プライバシーポリシー</h1>
      <p>
        FinalQuestX（以下「当社」といいます。）は、当社の提供するサービスであるLIFE
        MISSION（以下、「本サービス」といいます。）
        における個人情報の取扱について、以下のとおりプライバシーポリシー（以下、「本ポリシー」といいます。）を定めます。
        <br />
        1. 情報を取得するアプリ提供者
        <br />
        2. 個人情報の取得方法と利用目的
        <br />
        3. 個人情報の第三者提供
        <br />
        4. 個人情報の管理
        <br />
        5. 個人情報の開示、訂正、利用停止及び消去等
        <br />
        6. お問い合わせ窓口
        <br />
        7. プライバシーポリシーの変更手続
        <br />
        8. 改定日・制定日,
      </p>
      <h2>1. 情報を取得するアプリ提供者</h2>
      <p>当社のサービスは、作田陽樹と申す者によって開発、提供されています。</p>
      <h2>2. 個人情報の取得方法と利用目的</h2>
      <p>
        当社は、本サービスを通じて利用者から情報の取得を行います。
        <br />
        個人情報を収集・利用する目的は以下のとおりです。
        <br />
        （1）
        本サービスに関する登録の受付、本人確認等の提供・運営、保護及び改善のため
        <br />
        （2） 本サービスに関するご案内、各種お問い合わせ等への対応のため
        <br />
        （3）
        本サービスに関する当社の規約、ポリシー等（以下「規約等」といいます。）に違反する行為に対する対応のため
        <br />
        （4） 本サービスに関する規約等の変更等を通知するため
        <br />
        （5） 上記の利用目的に付随する目的のため
      </p>
      <h2>3. 安全確保の措置</h2>
      <p>
        当社は、収集した情報の漏えい、滅失又は毀損の防止その他収集した情報の適切な管理のために必要な措置を講じます。
        また、個人情報の取り扱いを委託する際には委託先に対しても個人情報を適切に管理するよう監督いたします。
        なお、委託先は、当社に代わって業務を遂行するために必要最低限の個人情報にのみアクセスし、委託業務の範疇を超えて個人情報を利用することはありません。
        当社が、安全管理のために講じた措置の概要は以下のとおりです。措置の具体的内容については、本ポリシーで定める窓口に対する利用者からの求めに応じて遅滞なく回答いたします。
        <br />
        （1） 基本方針の策定、個人情報の取扱いに係る規律の整備
        <br />
        （2） 個人情報の取扱責任者や報告連絡体制の整備
        <br />
        （3） 責任者以外個人情報を容易に閲覧できないような措置の実施
        <br />
        （4） 個人情報を取り扱う機器等の盗難紛失等を防止するための措置を実施
      </p>
      <h2>4. 個人情報の第三者提供</h2>
      <p>
        当社は、次に掲げる場合を除いて、あらかじめ利用者の同意を得ないで、取得した個人情報を第三者に提供することはありません。
        <br />
        （1） 法令に基づく場合
        <br />
        （2）
        国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、利用者の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
        <br />
        （3） その他法令で第三者提供の制限の例外が認められている場合
        <br />
        （4）
        当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託することに伴って当該個人情報が提供される場合
        <br />
        （5） 合併その他の事由による事業の承継に伴って個人情報が提供される場合
        <br />
        （6） 上記の利用目的に付随する目的のため
      </p>
      <h2>5. 個人情報の開示、訂正等の手続</h2>
      <p>
        利用者は、本条及び当社の関連規程に従って、当社に対し、個人情報保護法において認められる限度で、個人情報の開示・追加・削除、利用停止・消去等をご請求様がご本人であることを確認の上、同法に伴い、適切に対応いたします。
        詳しくは以下のお問い合わせ先までご連絡ください。
      </p>
      <h2>6. お問い合わせ窓口</h2>
      <p>
        当社へのお問い合わせは、開発者へ直接行います。
        <br />
        本サービスのマイページのお問い合わせよりお手続きください。
        <br />
        上記が不可能な場合下記の連絡先にご連絡ください
        <br />
        個人情報取り扱い責任者：作田陽樹
        <br />
        メールアドレス：haruki2021promoter@gmail.com
      </p>
      <h2>7. プライバシーポリシーの変更手続</h2>
      <p>
        当社は、必要に応じて、本ポリシーを変更します。
        <br />
        但し、法令上ご利用者の同意が必要となるような本ポリシーの変更を行う場合、
        <br />
        変更後の本ポリシーは当社所定の方法で変更に同意したご利用者に対してのみ適用されるものとします。
        <br />
        なお、当社は本ポリシーを変更する場合には変更後の本ポリシーの施行時期及び内容を適切な方法により周知、
        <br />
        又はご利用者に通知します。,
      </p>
      <h2>8. 改定日・制定日</h2>
      <p>
        改定日: 2024年4月1日
        <br />
        制定日: 2024年4月1日
      </p>
    </div>
  );
}

export default PrivacyPolicy;
